import React from 'react'
import styles from '../UserCard.module.scss'
import ColleagueItem from './ColleagueItem/ColleagueItem'
import { isEmpty } from 'lodash/lang'
import { ReactComponent as NoInfoImage } from '../../../assets/images/collegues_stub.svg'
import { useMediaQuery } from '@mui/material'
import Masonry from 'react-responsive-masonry'

const Colleagues = ({ userCardData }) => {
  const { colleagues } = userCardData
  const isCompactView = useMediaQuery('(max-width:767.98px)')
  if (isEmpty(colleagues)) {
    return (
      <div className={styles.noInfo}>
        <NoInfoImage width={isCompactView ? '100%' : 400} height={isCompactView ? 'auto' : 260} />
        <p>
          Currently, no colleagues have been identified in your profile based on shared vessel and <br />
          contract period experiences. This could be because your experience details are not fully <br /> updated or
          potential colleagues are not registered on NextShip.{' '}
        </p>
      </div>
    )
  }

  const colleagueCards = (colleagues || []).flatMap((group, groupIndex) => {
    const groupColleagues = group?.colleagues || []

    return groupColleagues.map((item, index) => {
      return {
        ...item,
        vessel_name: group?.vessel_name,
        vessel_date_from: group?.date_from,
        vessel_date_to: group?.date_to,
        __key: `${group?.vessel_name || 'vessel'}-${group?.date_from || ''}-${
          group?.date_to || ''
        }-${groupIndex}-${index}`,
      }
    })
  })

  return (
    <div className={styles.colleaguesCardsSection}>
      <Masonry columnsCount={isCompactView ? 1 : 2} gutter='16px'>
        {colleagueCards.map((colleague) => (
          <ColleagueItem key={colleague.__key} colleague={colleague} isCompactView />
        ))}
      </Masonry>
    </div>
  )
}
export default Colleagues
